export const keyNamesForValues = {
    getFirstUnPaidAmt: "getFirstUnPaidAmt",
    sumUnpaidAmounts: "sumUnpaidAmounts",
    getLastInstallmentDueDate: "getLastInstallmentDueDate",
    sumPaidAmounts: "sumPaidAmounts",
    countUnpaidInstallments: "countUnpaidInstallments"
} as const

export const installmentsStatus = {
    paid: "paid",
    pending: "pending"
} as const